import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { menuAnatomy } from '@chakra-ui/anatomy';
import getThemes, { ThemesKeys } from '../shared/themeShared';
import DropDownShared from '../shared/dropdown';

const style = createMultiStyleConfigHelpers(menuAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    ...DropDownShared(theme).baseStyle,
    list: {
      ...DropDownShared(theme)?.baseStyle?.list,
      borderRadius: getThemes(theme).radii.lg,
    },
    groupTitle: {
      ...DropDownShared(theme)?.baseStyle?.groupTitle,
    },
    item: {
      ...DropDownShared(theme)?.baseStyle?.item,
    },
    divider: {
      ...DropDownShared(theme)?.baseStyle?.divider,
    },
  });

export const dropdownTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
  });

export default (theme: any) => dropdownTheme(theme);
